<template> 
  <div id="boxHistoricoConfiguracoes">  
        <h3>Histórico de Configurações</h3> 
        <table class="table table-striped table-bordered">
          <thead> 
            <tr>  
              <td>Quantidade Assessores</td>
              <td>Intervalo Atendimento</td>
              <td>Início Atendimento</td> 
              <td>Fim Atendimento</td>
              <td>Fim Admissão</td>
              <td>Bloqueio Agenda Inicio</td>
              <td>Bloqueio Agenda Fim</td>
              <td>Usuario</td>
              <td>Data Modificação</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of historico">
              <td>{{ item.QuantidadeAssessores }}</td>
              <td>{{ item.IntervaloAtendimento }}</td>
              <td>{{ item.InicioAtendimento }}</td>
              <td>{{ item.FimAtendimento }}</td>
              <td>{{ item.FimAdmissao }}</td>
              <td>{{ item.BloqueioAgendaInicio }}</td>
              <td>{{ item.BloqueioAgendaFim }}</td>
              <td>{{ item.NomeUsuario }}</td>
              <td>{{ dataFormatada(item.DataAlteracao) }}</td>   
            </tr>
            <tr v-if="historico.length == 0">
              <td colspan="9">Não há resultados para exibir</td>
            </tr>
          </tbody> 
          <tfoot> 
            <tr>
              <td colspan="9" > </td>
            </tr>
          </tfoot>
        </table>  
    </div> 
</template>
<script>
import moment from 'moment'
export default {
  created () {
    moment.locale('pt-BR')
    this.get()
  },
  components: {
    moment
  },
  methods: {
    get () {
      this.$http.get('configuracao/historico?unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.historico = res.body
      })
    },
    dataFormatada (data) {
      return moment(data).format('LLLL')
    }
  },
  data () {
    return {
      historico: []
    }
  }
}
</script>
<style> 
</style>



// WEBPACK FOOTER //
// Historico.vue?b14b68f4